import React from "react";

// * Components
import Book from "../../components/Book-Section/Book";
import PageInfo from "../../components/Products-Info-Section/PageInfo";

// * Datas
import { Horrors } from "../../Data/ProductData";
import { homeObjOne } from "./Data";

function Horror() {
  return (
    <>
      <PageInfo {...homeObjOne} />
      <Book items={Horrors} />
    </>
  );
}

export default Horror;
